import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

export const features = [
  {
    title: "Explore Books by Language",
    description:
      "Navigate literature from around the world, from French classics to Japanese modernist novels, all organized by language for effortless discovery.",
    imgSrc: "../media/nib.jpg",
    alt: "Books organized by language in a minimalist interface.",
  },
  {
    title: "Concise, Curated Summaries",
    description:
      "Each book features a brief overview, key context, and author background, enough to spark curiosity without overwhelming detail.",
    imgSrc: "../media/shelf.jpg",
    alt: "Curated bookshelf with short literary summaries.",
  },
  {
    title: "Discover Without Limits",
    description:
      "Explore a thoughtfully curated collection of books and uncover hidden gems from every tradition, all presented in a clean, monochrome design.",
    imgSrc: "../media/to-read.jpg",
    alt: "Minimal reading list showcasing global literature.",
  },
  {
    title: "Focus on Discovery, Not Overload",
    description:
      "Our minimalist approach ensures you can focus on the literature itself. Reading, learning, and connecting across cultures; without distraction.",
    imgSrc: "../media/typewriter.jpg",
    alt: "Minimal workspace focused on reading and writing.",
  },
  {
    title: "Stay Engaged",
    description:
      "Dive deeper with contextual insights, quotes, and cross-references that make each literary journey immersive and memorable.",
    imgSrc: "../media/author.jpg",
    alt: "Author notes and contextual literary insights.",
  },
  {
    title: "Inclusive and Scalable",
    description:
      "Begin with a carefully curated foundation and expand naturally as new voices, languages, and traditions are added over time.",
    imgSrc: "../media/reading.jpg",
    alt: "Reader exploring books across cultures.",
  },
];

export const FourthSection = () => {
  useEffect(() => {
    AOS.init({
      duration: 900,
      easing: "ease-out-cubic",
      once: false,
    });
  }, []);

  return (
    <section id="features" className="py-5" style={{ backgroundColor: "#ffffff" }}>
      <div className="container text-center">
        {/* Tag */}
        <div
          className="d-inline-block mb-3 px-3 py-1 rounded-pill border"
          style={{
            backgroundColor: "#ffffff",
            boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
          }}
          data-aos="fade-up"
        >
          <span className="fw-bold text-dark">Why Biblivium</span>
        </div>

        {/* Heading */}
        <h2
          className="mb-3 fw-bold"
          style={{ maxWidth: "700px", margin: "0 auto" }}
          data-aos="fade-up"
          data-aos-delay="100"
        >
          A Minimalist Platform for Maximum Discovery
        </h2>

        {/* Subtitle */}
        <p
          className="text-muted mb-5"
          style={{ maxWidth: "700px", margin: "0 auto" }}
          data-aos="fade-up"
          data-aos-delay="200"
        >
          Built for readers who want clarity, focus, and effortless exploration
          of the world’s literary treasures; without overwhelming detail or
          cluttered interfaces.
        </p>

        {/* Feature Cards */}
        <div className="row g-4">
          {features.map((feature, idx) => (
            <div
              key={idx}
              className="col-12 col-md-6 col-lg-4 d-flex mb-4"
              data-aos="zoom-in"
              data-aos-delay={idx * 100}
            >
              <div className="card flex-fill h-100 shadow-sm border-0 rounded-4 text-center p-3">
                <img
                  src={feature.imgSrc}
                  className="card-img-top mb-3"
                  alt={feature.alt}
                  style={{ objectFit: "contain", maxHeight: "220px" }}
                />
                <div className="card-body px-0">
                  <h5 className="card-title fw-semibold">{feature.title}</h5>
                  <p className="card-text text-secondary">
                    {feature.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
